export const HEADERS = {
  X_EXPERIMENTS: 'x-experiments',
  X_FORWARDED_FOR: 'x-forwarded-for',
  X_FORWARDED_HOST: 'x-forwarded-host',
  X_FORWARDED_PROTO: 'x-forwarded-proto',
  X_RECAPTCHA_TOKEN: 'x-recaptcha-token',
} as const
